import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { get } from "../../lib/sessionClient";
import { useDispatch } from "react-redux";
import {
  setReset,
  setCopyData,
  setData,
  setSortStatus,
  setError,
  setSecondCopyData,
  setErrMessage,
} from "../../redux/dataSlice";
import { changeExpenseAmountData } from "../../functions/changeExpenseAmountData";
import { setFilteredData, setIsFiltered } from "../../redux/isTableFilterSlice";
import { clearLocalStorageSession } from "../../lib/authUtils";

const useFetchData = (apiEndPoint, dataAmountWillChange, currentListTab) => {
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const dispatch = useDispatch();
  const fetchData = async () => {
    dispatch(setReset());
    try {
      const response = await get(apiEndPoint);
      if (dataAmountWillChange) {
        const changedExpenseAmountData = changeExpenseAmountData(
          response.data,
          dataAmountWillChange
        );
        if (currentListTab) {
          dispatch(setSecondCopyData(changedExpenseAmountData));
        }
        const updateDataByTab = currentListTab
          ? changedExpenseAmountData[currentListTab]
          : changedExpenseAmountData;
        dispatch(setData(updateDataByTab));
        dispatch(setCopyData(updateDataByTab));
      } else {
        dispatch(setData(response.data));
        dispatch(setCopyData(response.data));
      }
      dispatch(setSortStatus(false));
      dispatch(setFilteredData([]));
      dispatch(setIsFiltered(false));
    } catch (error) {
      if (error.response?.status === 401) {
        clearLocalStorageSession();
        navigate("/login");
      } else {
        dispatch(setError());
        dispatch(setErrMessage(error.response?.data?.message || error.message));
      }
    } finally {
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    fetchData,
    isLoaded,
  };
};

export default useFetchData;
